import { baseHttp } from "./baseHttp";

export interface BackendVersion {
  version: string;
  release_date: string;
  commit_hash: string;
  branch: string;
}

export interface FrontendVersion {
  commit: string;
  branch: string;
  timestamp: string;
  installation?: string;
}

const getBackendVersion = async (): Promise<BackendVersion> => {
  return baseHttp.get(`/api/n/version?t=${new Date().getTime()}`).then((response: any) => response.data);
};

const getFrontendVersion = async (): Promise<FrontendVersion> => {
  // La UI espone il suo version.json su assets/version.json relativo al baseUrl
  // Dobbiamo chiamare l'endpoint della UI, non del BE
  const response = await fetch(`/assets/version.json?t=${new Date().getTime()}`);
  return response.json();
};

const VersionService = {
  getBackendVersion,
  getFrontendVersion,
};

export default VersionService;
